import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "flex flex-col w-full min-h-screen" }
const _hoisted_3 = { class: "container flex gap-2 justify-between max-w-5xl mx-auto overflow-x-auto p-5 pb-3 xl:flex-row" }
const _hoisted_4 = { class: "flex gap-2 items-center" }
const _hoisted_5 = { class: "h1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  width: "6",
  height: "10",
  viewBox: "0 0 6 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "1",
    y1: "9.29289",
    x2: "5.29289",
    y2: "5",
    stroke: "#222B45",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5.29289",
    y1: "5",
    x2: "1",
    y2: "0.707107",
    stroke: "#222B45",
    "stroke-linecap": "round"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "h1" }, "Members", -1)
const _hoisted_8 = { class: "container flex gap-2 justify-between max-w-5xl mx-auto px-5 py-3" }
const _hoisted_9 = { class: "flex gap-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  width: "6",
  height: "10",
  viewBox: "0 0 6 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5",
    y1: "0.707107",
    x2: "0.707106",
    y2: "5",
    stroke: "#222B45",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "0.707107",
    y1: "5",
    x2: "5",
    y2: "9.29289",
    stroke: "#222B45",
    "stroke-linecap": "round"
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Back", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "+ Add Member", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "container flex flex-col gap-2 max-w-5xl mx-auto overflow-x-auto p-5 pb-32" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"box-head-blank justify-between\"><div class=\"flex gap-4 items-center\"><div class=\"h-4 w-8\"></div><div class=\"w-40\"><span class=\"text-order\">Name</span></div><div class=\"w-44\"><span class=\"text-order\">Email</span></div><div class=\"w-28\"><span class=\"text-order\">Phone</span></div><div class=\"flex justify-center w-24\"><span class=\"text-order\">Role</span></div><div class=\"flex justify-center w-24\"><span class=\"text-order\">Orders</span></div></div><div class=\"flex gap-4 justify-end\"><div class=\"flex justify-center w-36\"><span class=\"text-order\">Status</span></div><div class=\"flex justify-end w-9\"></div></div></div>", 1)
const _hoisted_17 = { class: "flex gap-4 items-center" }
const _hoisted_18 = { class: "w-8" }
const _hoisted_19 = { class: "avatar" }
const _hoisted_20 = { class: "w-40" }
const _hoisted_21 = { class: "text-title" }
const _hoisted_22 = { class: "w-44" }
const _hoisted_23 = { class: "text truncate" }
const _hoisted_24 = { class: "w-28" }
const _hoisted_25 = { class: "text truncate" }
const _hoisted_26 = { class: "flex justify-center w-24" }
const _hoisted_27 = { class: "text" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-24" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "10")
], -1)
const _hoisted_29 = { class: "flex gap-4 items-center" }
const _hoisted_30 = { class: "text w-24" }
const _hoisted_31 = {
  class: "flex justify-start w-9",
  style: { right: '0px' }
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_action = _resolveComponent("action")!
  const _component_memberModal = _resolveComponent("memberModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.store.state.storeDetails.name), 1),
          _hoisted_6,
          _hoisted_7
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: "button-back cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/store/${_ctx.$route.params.id}`)))
          }, _hoisted_12),
          _createElementVNode("div", {
            class: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleAddMember && _ctx.toggleAddMember(...args)))
          }, _hoisted_14)
        ]),
        _createVNode(_component_AutoComplete, {
          modelValue: _ctx.selectedRole,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedRole) = $event)),
          items: _ctx.Roles,
          "return-by": "'value'",
          "track-by": "value",
          "filter-by": "value",
          "show-by": "value",
          placeholder: "Roles",
          "show-close": true,
          onSubmit: _cache[3] || (_cache[3] = (val) => _ctx.updateData(val)),
          onClose: _cache[4] || (_cache[4] = (val) => _ctx.updateData(val))
        }, null, 8, ["modelValue", "items"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.state.storeDetails
            .member, ({ user, status, id, role }, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "box-blank justify-between min-w-max",
            key: idx
          }, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", null, _toDisplayString(`${user.firstName[0]}${user.lastName[0]}`.toUpperCase()), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("p", _hoisted_21, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("p", _hoisted_23, _toDisplayString(user.email), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("p", _hoisted_25, _toDisplayString(user.phone), 1)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("span", _hoisted_27, _toDisplayString(role), 1)
              ]),
              _hoisted_28
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("span", _hoisted_30, _toDisplayString(status), 1),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_action, {
                  onDeleted: (id) => _ctx.deleteItem(id),
                  index: `action-${idx}`,
                  Id: id,
                  data: { role, email: user.Email, userId: user.Id },
                  roles: _ctx.Roles,
                  onUpdated: _cache[5] || (_cache[5] = (val) => _ctx.updateItem(val))
                }, null, 8, ["onDeleted", "index", "Id", "data", "roles"])
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    (_ctx.addMember)
      ? (_openBlock(), _createBlock(_component_memberModal, {
          key: 0,
          modelValue: _ctx.SaveStoreUserMode,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.SaveStoreUserMode) = $event)),
          onClose: _ctx.toggleAddMember,
          onSubmit: _cache[7] || (_cache[7] = (val) => _ctx.addStoreUser(val)),
          items: _ctx.Roles
        }, null, 8, ["modelValue", "onClose", "items"]))
      : _createCommentVNode("", true)
  ]))
}